/**
 * Demo app that shows only the trading layout (LayoutOnlyPage).
 * No navigation, header, or other test pages. Use for embedding or standalone demo.
 * Shows onboard modal on first visit to choose connection method.
 */
import "./App.css";
import LayoutOnlyPage from "./test_pages/LayoutOnlyPage";
import { AppProvider } from "./context/AppContext";
import { Toaster } from "./components/ui/Toaster";

function AppDemo(): JSX.Element {
  return (
    <AppProvider>
      <div className="App ADemo">
        <main className="App-main">
          <LayoutOnlyPage />
        </main>
      </div>
      <Toaster
        position="bottom-right"
        toastOptions={{
          duration: 4000,
          style: {
            color: "var(--foreground)",
            border: "1px solid var(--border)",
          },
        }}
      />
    </AppProvider>
  );
}

export default AppDemo;
